import React, { useState, useEffect }  from "react";
import { useParams, Link } from 'react-router-dom';
import Navigation from "../Navigation";
import DefaultImg from "./../../images/webinar-img.jpeg";
import { getWithExpiry, setWithExpiry } from '../../common';
import {Helmet} from "react-helmet";
import configVars from "../../config";
import HorizontalNav from "../Dashboard/HorizontalNav";

const SingleWebinar = () => {

    const { webinarid } = useParams();
    const [postTitle, setPostTitle] = useState('');
    const [postContent, setPostContent] = useState('');
    const [postImage, setPostImage] = useState('');
    const [isLoading, setIsLoading] = useState(false);


	useEffect(() => {

        const savedPostData = getWithExpiry( `sy_post_${webinarid}_data`);

        if ( savedPostData ) {

            setPostTitle(savedPostData.post_title);
            setPostContent(savedPostData.post_content);
            setPostImage(savedPostData.post_thumbnail);   

        } else {

            setIsLoading(true);

            (async () => {

                const response = await fetch(
                    `${configVars.apiUrl}sustainchange/v1/getpostsbyid/?postid=${webinarid}`,
                    {
                        method: "GET",
                        headers: {
                            Authorization: `Basic ${configVars.auth}`,
                        },
                    }
                );
    
                const postResponse = await response.json();
    
                if ( postResponse ) {

                    if ( postResponse.success === true ) {

                        setWithExpiry( `sy_post_${webinarid}_data`, postResponse.data );
                        setPostTitle(postResponse.data.post_title);
                        setPostContent(postResponse.data.post_content);
                        setPostImage(postResponse.data.post_thumbnail); 

                    }

					setIsLoading(false);
                    
                }
    
            })()

        }

		

	}, [webinarid]);
  
    return (
      <div className="main-wrapper">
        <Helmet>
          <title>{postTitle}</title>
          <meta name="description" content="" />
        </Helmet>
        <Navigation />

        <div className="page-content-wrap">
          <HorizontalNav title="DIGITALA TRÄFFAR" />

          <div className="pt-5 pt-lg-0 page-content-inner">
            <div
              className="course-img-wrap d-flex overflow-hidden position-relative"
              style={{ maxHeight: "300px" }}
            >
              {isLoading && (
                <img
                  src={DefaultImg}
                  alt="te"
                  className="w-100"
                  style={{ objectFit: "cover" }}
                />
              )}
              {!isLoading && postImage && (
                <img
                  src={postImage}
                  alt="te"
                  className="w-100"
                  style={{ objectFit: "cover" }}
                />
              )}
              {!isLoading && !postImage && (
                <img
                  src={DefaultImg}
                  alt="te"
                  className="w-100"
                  style={{ objectFit: "cover" }}
                />
              )}
              <div className="course-img-overlay position-absolute w-100 h-100 d-flex justify-content-center align-items-center flex-column dark-overlay">
                <div className="flex-grow-1 d-flex align-items-center">
                  <h2
                    className="text-white display-6 text-center text-shadow single-article-title"
                    dangerouslySetInnerHTML={{ __html: postTitle }}
                  ></h2>
                </div>
                <span className="text-white p-3 d-flex w-100 dark-overlay">
                  <span className="text-white pe-3">
                    <i className="fa fa-long-arrow-left" aria-hidden="true"></i>
                  </span>
                  <Link to={`/digitala-traffar/`} className="text-white">
                    Gå tillbaka
                  </Link>
                </span>
              </div>
            </div>

            <div className="row g-0">
              <div className="col-12 px-4 pt-5 pb-6 single-article-wrap">
                {isLoading && (
                  <div className="d-flex justify-content-center mt-5">
                    <div className="spinner-border text-primary" role="status">
                      <span className="visually-hidden">Loading...</span>
                    </div>
                  </div>
                )}

                {postContent && !isLoading && (
                  <div
                    className="mx-auto text-lg"
                    style={{ maxWidth: "750px" }}
                    dangerouslySetInnerHTML={{ __html: postContent }}
                  ></div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
};

export default SingleWebinar;
